import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { ThemeProvider } from "@shared/context/ThemeContext";
import { DataProvider } from "@shared/context/DataContext";
import { CookieConsentProvider } from "@shared/context/CookieConsentContext";
import CookieConsentBanner from "@shared/components/CookieConsent/CookieConsentBanner";
import UserProvider from "@shared/context/user";
import Home from "../components/Views/Home/Home";
import Contact from "../components/Views/PublicPages/Contact";
import Privacy from "../components/Views/PublicPages/Privacy";
import Terms from "../components/Views/PublicPages/Terms";
import Register from "../components/Views/PublicPages/Register";
import RequestVerificationEmail from "../components/Views/PublicPages/RequestVerificationEmail";
import VerifyEmail from "../components/Views/PublicPages/VerifyEmail";
import StripeCancelPage from "../components/Views/PublicPages/StripeCancel";
import StripeSuccessPage from "../components/Views/PublicPages/StripeSuccess";
import UseCaseRoute from "../components/Views/PublicPages/UseCaseRoute";
import ForgotPassword from "../components/Views/PublicPages/ForgotPassword";
import ResetPassword from "../components/Views/PublicPages/ResetPassword";
import CommunityDrip from "../components/Views/CommunityDrip/CommunityDrip";
import ShareDripPoC from "../components/Views/ShareDrip/ShareDripPoC";
import ChatWidget from "@shared/components/ChatWidget/ChatWidget";
import MaintenanceBanner from "@shared/components/MaintenanceBanner";
import ErrorBoundary from "@shared/components/ErrorBoundary";
import BlogIndex from "../components/Views/Blog/BlogIndex";
import BlogPost from "../components/Views/Blog/BlogPost";
import Support from "../components/Views/PublicPages/Support";
import SupportAgentPage from "../components/Views/PublicPages/SupportAgentPage";
import CookiePolicy from "../components/Views/PublicPages/CookiePolicy";
import AccessibilityStatement from "../components/Views/PublicPages/AccessibilityStatement";
import DoNotSellOrShare from "../components/Views/PublicPages/DoNotSellOrShare";
import { useCookieConsentOptional } from "@shared/context/CookieConsentContext";

function AppChrome() {
  const { pathname } = useLocation();
  const isOperatorSupport = pathname.startsWith("/support/agent/");
  const consent = useCookieConsentOptional();
  const chatAllowed = consent?.allowsFunctional ?? false;

  return (
    <>
      <MaintenanceBanner />
      {!isOperatorSupport && chatAllowed && <ChatWidget />}
      <CookieConsentBanner />
    </>
  );
}

export default function Router() {
  return (
    <ThemeProvider>
      <CookieConsentProvider>
        <UserProvider>
          <DataProvider>
            <ErrorBoundary>
              <BrowserRouter>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/drip" element={<CommunityDrip />} />
                  <Route path="/drip/:curatorId" element={<CommunityDrip />} />
                  <Route path="/share-drip/:token" element={<ShareDripPoC />} />
                  <Route path="/blog" element={<BlogIndex />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                  <Route path="/use-cases/:slug" element={<UseCaseRoute />} />

                  <Route path="/register" element={<Register />} />
                  <Route path="/email-verify" element={<RequestVerificationEmail />} />
                  <Route path="/verify-email" element={<VerifyEmail />} />

                  <Route path="/contact" element={<Contact />} />
                  <Route path="/support" element={<Support />} />
                  <Route path="/support/agent/:shortId" element={<SupportAgentPage />} />
                  <Route path="/privacy-policy" element={<Privacy />} />
                  <Route path="/terms-of-service" element={<Terms />} />
                  <Route path="/cookie-policy" element={<CookiePolicy />} />
                  <Route path="/accessibility" element={<AccessibilityStatement />} />
                  <Route path="/do-not-sell-or-share" element={<DoNotSellOrShare />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route path="/stripe/default/success" element={<StripeSuccessPage />} />
                  <Route path="/stripe/default/cancel" element={<StripeCancelPage />} />
                </Routes>
                <AppChrome />
              </BrowserRouter>
            </ErrorBoundary>
          </DataProvider>
        </UserProvider>
      </CookieConsentProvider>
    </ThemeProvider>
  );
}
